import AdminProductionList from './AdminProductionList';

export default AdminProductionList;
